<template>
  <div class="boxes">
    <b-row>
      <b-modal id="create_vbox" hide-header="true" hide-footer="true">
        <b-row>
          <b-col>
            <h3>Create a Virtual Box</h3>
            <hr />
            <br />

            <b-form @submit="createVB">
              <div class="text-center">Box Details</div>
              <br />

              <div class="form-group mb-3 input-group input-text-wrapper">
                <div class="input-group-prepend">
                  <span
                    class="input-group-text"
                    style="background-color: #ffffff; border: none"
                  >
                    <font-awesome-icon icon="random" style="color: #ced4da" />
                  </span>
                </div>
                <b-form-select
                  class="box-text-input"
                  v-model="branch_id"
                  required
                >
                  <b-select-option :value="null">Choose Branch</b-select-option>
                  <b-select-option
                    v-for="branch in getPostOffices"
                    :key="branch"
                    :value="branch.branch_id"
                  >
                    {{ branch.name }}
                  </b-select-option>
                </b-form-select>
              </div>

              <div class="form-group mb-3 input-group input-text-wrapper">
                <div class="input-group-prepend">
                  <span
                    class="input-group-text"
                    style="background-color: #ffffff; border: none"
                  >
                    <font-awesome-icon
                      icon="user-circle"
                      style="color: #ced4da"
                    />
                  </span>
                </div>
                <b-form-select
                  v-model="acc_type"
                  class="box-text-input"
                  required
                >
                  <b-select-option :value="null">Account Type</b-select-option>
                  <b-select-option value="Individual"
                    >Individual</b-select-option
                  >
                  <b-select-option value="Company">Company</b-select-option>
                </b-form-select>
              </div>

              <div class="text-center">Identification</div>
              <br />

              <div class="form-group mb-3 input-group input-text-wrapper">
                <div class="input-group-prepend">
                  <span
                    class="input-group-text"
                    style="background-color: #ffffff; border: none"
                  >
                    <font-awesome-icon
                      icon="map-marker"
                      style="color: #ced4da"
                    />
                  </span>
                </div>
                <b-form-input
                  class="box-text-input"
                  v-model="address"
                  type="text"
                  required
                  placeholder="Physical Address"
                ></b-form-input>
              </div>

              <div class="form-group mb-3 input-group input-text-wrapper">
                <div class="input-group-prepend">
                  <span
                    class="input-group-text"
                    style="background-color: #ffffff; border: none"
                  >
                    <font-awesome-icon
                      icon="venus-mars"
                      style="color: #ced4da"
                    />
                  </span>
                </div>
                <b-form-select v-model="gender" class="box-text-input" required>
                  <b-select-option :value="null">Gender</b-select-option>
                  <b-select-option value="Male">Male</b-select-option>
                  <b-select-option value="Female">Female</b-select-option>
                </b-form-select>
              </div>

              <div class="form-group mb-3 input-group input-text-wrapper">
                <div class="input-group-prepend">
                  <span
                    class="input-group-text"
                    style="background-color: #ffffff; border: none"
                  >
                    <font-awesome-icon icon="id-card" style="color: #ced4da" />
                  </span>
                </div>
                <b-form-select
                  v-model="id_type"
                  class="box-text-input"
                  required
                >
                  <b-select-option :value="null"
                    >Identification Type</b-select-option
                  >
                  <b-select-option value="National ID"
                    >National ID</b-select-option
                  >
                  <b-select-option value="Passport">Passport</b-select-option>
                  <b-select-option value="Driving Permit"
                    >Driving Permit</b-select-option
                  >
                </b-form-select>
              </div>

              <div class="form-group mb-3 input-group input-text-wrapper">
                <div class="input-group-prepend">
                  <span
                    class="input-group-text"
                    style="background-color: #ffffff; border: none"
                  >
                    <font-awesome-icon icon="id-badge" style="color: #ced4da" />
                  </span>
                </div>
                <b-form-input
                  class="box-text-input"
                  v-model="id_number"
                  type="text"
                  required
                  placeholder="ID Number"
                ></b-form-input>
              </div>

              <br />
              <b-form-group>
                <button
                  class="form-control signUpButtonCard button"
                  type="submit"
                >
                  Verify Code &nbsp;
                  <b-spinner
                    v-if="boxSpinner"
                    small
                    label="Loading..."
                  ></b-spinner>
                </button>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
      </b-modal>
    </b-row>

    <div style="width: 98%; margin-top: 40px" class="mx-auto">
      <b-row>
        <b-col lg="6">
          <b-card>
            <b-row>
              <b-col>
                <h4>Physical Boxes</h4>
              </b-col>
              <b-col class="d-flex justify-content-end">
                <b-button
                  size="sm"
                  href="/dashboard/apply-box"
                  style="color: #db0000"
                  squared
                  variant="outline-danger"
                  >Apply For a Box</b-button
                >
              </b-col>
            </b-row>

            <hr />

            <br />

            <b-table-simple>
              <tr>
                <td></td>
              </tr>
            </b-table-simple>
          </b-card>
        </b-col>

        <b-col lg="6">
          <b-card>
            <b-row>
              <b-col>
                <h4>Virtual Boxes</h4>
              </b-col>
              <b-col class="d-flex justify-content-end">
                <b-button
                  size="sm"
                  squared
                  v-b-modal="'create_vbox'"
                  variant="outline-danger"
                  >Register</b-button
                >
              </b-col>
            </b-row>

            <hr />
            <br />

            <b-col col lg="12">
              <Box :data="getVirtualBox.data" />
            </b-col>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Box from "@/views/dashboard/boxes/component/Box";

export default {
  name: "PostalBoxes",
  components: { Box },
  data() {
    return {
      branch_id: null,
      mode: null,
      gender: null,
      acc_type: null,
      id_type: null,
      id_number: null,
      address: null,
      time_of_expiry: null,
      cost: 12000,
      boxSpinner: null,
    };
  },
  computed: {
    ...mapGetters([
      "getPhysicalBoxes",
      "getVirtualBox",
      "getMessage",
      "getAccount",
      "getPostOffices",
      "getClientId",
    ]),
    /* msg_response() {
      return this.getMessage
    },*/
  },
  watch: {
    msg_response(newValue) {
      alert(newValue.message);
    },
  },
  mounted() {
    let data = {
      client_id: this.getClientId,
      address_type: "Virtual",
    };
    this.fetchVirtualBox(data);
    this.fetchPostOffices();
  },
  methods: {
    ...mapActions([
      "createVBox",
      "fetchVirtualBox",
      "fetchPhysicalBoxes",
      "fetchPostOffices",
    ]),
    /* createPB: function (e) {
      e.preventDefault()
    },*/
    createVB: function (e) {
      e.preventDefault();

      let data = {
        client_id: this.getClientId,
        branch_id: this.branch_id,
        address: this.address,
        gender: this.gender,
        acc_type: this.acc_type,
        acc_id_type: this.id_type,
        acc_id_no: this.id_number,
      };
      this.createVBox(data);
      this.$bvModal.hide("create_vbox");
    },
    applyForaBox() {
      this.$router.push("/mail");
    },
  },
};
</script>

<style scoped>
.box {
  margin: 10px;
  box-shadow: 5px 5px 5px #dedede;
  background: #fff;
  border-radius: 3px;
}

.title {
  color: #222;
  font-size: 18px;
}

.button {
  border: none;
  color: #ffffff;
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.14);
  font-weight: bold;
  background: #db0000;
  height: 45px;
  border-radius: 3px;
  text-align: center;
  font-size: 15px;
  margin-top: 3%;
}

.button:hover {
  background: #9f0012;
}

.box-holder {
  margin-left: -25px;
}

.input {
  width: 100%;
  margin-bottom: 10px;
}

.input-text-wrapper {
  border: #ced4da 1px solid;
  padding: 3px;
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.14);
  border-radius: 8px;
}

.box-text-input {
  border: none;
  font-size: 13px;
  height: 13vm;
  color: #8898aa;
  outline: none;
  box-shadow: none !important;
}

.order-cost {
  width: 100%;
  background: #5e5e5e;
  border-radius: 3px;
  font-size: 16px;
  color: white;
  font-weight: bold;
  padding: 8px;
}
</style>
